import {coreApi} from './core'

export const additionalContractService = {
    getAppNextNumber() {
        return coreApi.get(`/contract/additional/nextnumber`)
    },
    delete: id => coreApi.delete(`contract/appendix?id=${id}`),
    create(data) {
        return coreApi.post('contract/appendix', data)
    },
    update(data) {
        return coreApi.put('contract/appendix', data)
    },
    getAll() {
        return coreApi.get('contract/appendix')
    },
    getAppById(params) {
        return coreApi.get(`/contract/appendix`, {params})
    }
}
